import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';

// Animation configs - extracted to prevent re-renders
const bannerVariants = {
  initial: { x: -100, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: -100, opacity: 0 },
};

const bannerTransition = { type: 'spring', damping: 25 };

const CookieBanner = ({ onCustomise, onAcceptAll, onRejectAll }) => {
  const { t } = useLanguage();

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={bannerVariants}
      transition={bannerTransition}
      data-testid="cookie-banner"
      className="fixed bottom-6 left-6 z-50 max-w-sm bg-white rounded-xl shadow-2xl border border-gray-200 p-6"
    >
      <h3 className="text-lg font-bold text-gray-900 mb-2">
        {t.cookies?.bannerTitle || 'We value your privacy'}
      </h3>
      <p className="text-gray-600 text-sm mb-4">
        {t.cookies?.bannerDescription || 'We use cookies to enhance your browsing experience.'}
      </p>

      <div className="flex flex-col gap-2">
        <button
          onClick={onCustomise}
          data-testid="cookie-banner-customise-btn"
          className="w-full px-4 py-2 bg-white border-2 border-blue-500 text-blue-600 rounded-lg font-medium hover:bg-blue-50 transition-colors text-sm"
        >
          {t.cookies?.customise || 'Customise'}
        </button>
        <div className="flex gap-2">
          <button
            onClick={onRejectAll}
            data-testid="cookie-banner-reject-btn"
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors text-sm"
          >
            {t.cookies?.rejectAll || 'Reject All'}
          </button>
          <button
            onClick={onAcceptAll}
            data-testid="cookie-banner-accept-btn"
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors text-sm"
          >
            {t.cookies?.acceptAll || 'Accept All'}
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default CookieBanner;
